<div class="slide-image-container">
  @if (imageUrl(); as url) {
    <img [src]="url" [alt]="altText()" class="slide-image" />
  }
  <ng-content select="[overlay]"></ng-content>
</div>
<p class="slide-description" [ngStyle]="descriptionStyles | theme">{{ description() }}</p>
